import React from 'react'
import bg from '../../../public/static/image-background/logo-v-02.png'
import bgImage from '../../../public/static/image-background/ocean_blue_stadium_bg.png'
import { useTranslation, getBase64 } from '../../../constants/helpers'

const Mauranking5 = ({ dataTable, dataSeason, size, id }) => {
    const { t } = useTranslation()
    const width = size
    const px = width / 100

    const color = {
        first: '#00b4d8',     // Ocean Blue
        second: '#90e0ef',    // Light Cyan
        third: '#0077b6',     // Deep Blue
        fourth: '#caf0f8',    // Ice Blue
        text: '#ffffff',
        subText: 'rgba(202,240,248,0.8)',
        bg: '#03045e',        // Deep Navy
        rowEven: 'rgba(0,180,216,0.07)',
        rowOdd: 'rgba(3,4,94,0.85)'
    }

    return (
        <div id={id} style={{ width: width, minHeight: width / 1.3, padding: `${1.6 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', backgroundColor: color.bg, position: 'relative', overflow: 'hidden' }}>

            {/* Stadium background */}
            <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', zIndex: 0 }}>
                <Image src={bgImage} style={{ width: '100%', height: '100%', objectFit: 'cover', opacity: 0.4 }} />
                <div style={{ position: 'absolute', top: 0, left: 0, right: 0, bottom: 0, background: 'linear-gradient(to bottom, rgba(3,4,94,0.92) 0%, rgba(0,119,182,0.2) 40%, rgba(3,4,94,0.96) 100%)' }} />
            </div>

            <div style={{ position: 'relative', zIndex: 1, width: '100%', padding: `${px * 1.5}px`, display: 'flex', flexDirection: 'column' }}>

                {/* Header */}
                <div style={{
                    display: 'flex', flexDirection: 'row', justifyContent: 'space-between', alignItems: 'center',
                    background: `linear-gradient(90deg, rgba(0,119,182,0.15), rgba(0,180,216,0.25), rgba(0,119,182,0.15))`,
                    border: `1px solid rgba(0,180,216,0.4)`,
                    borderRadius: `${px * 1.5}px`,
                    padding: `${px * 1.2}px ${px * 1.5}px`,
                    marginBottom: `${px * 2}px`,
                    backdropFilter: 'blur(8px)'
                }}>
                    <div style={{ flex: 1 }}>
                        <Image src={dataSeason?.logo} style={{ width: `${px * 8}px`, height: `${px * 8}px`, objectFit: 'contain', filter: `drop-shadow(0 0 8px rgba(0,180,216,0.8))` }} />
                    </div>
                    <div style={{ flex: 6 }}>
                        <h1 style={{ textAlign: 'center', color: color.text, fontSize: `${2.8 * px}px`, textTransform: 'uppercase', letterSpacing: `${px * 0.2}px`, textShadow: `0 0 10px ${color.first}`, margin: 0 }}>{dataSeason?.name}</h1>
                    </div>
                    <div style={{ flex: 1, display: 'flex', justifyContent: 'flex-end' }}>
                        <Image src={bg} style={{ width: `${px * 8}px`, height: `${px * 8}px`, objectFit: 'contain' }} />
                    </div>
                </div>

                {/* Title */}
                <div style={{ textAlign: 'center', marginBottom: `${px * 2.5}px` }}>
                    <h1 style={{ color: color.second, fontSize: `${5 * px}px`, textTransform: 'uppercase', fontWeight: 'bold', letterSpacing: `${px * 0.3}px`, textShadow: `0 0 20px rgba(0,180,216,0.9), 0 0 40px rgba(0,180,216,0.4)`, margin: 0, lineHeight: 1.1 }}>
                        {t('rankings')}
                    </h1>
                </div>

                {/* Tables */}
                {dataTable.map((group, groupIdx) => (
                    <div key={`${groupIdx}${group?.id}`} style={{ width: '100%', marginBottom: `${px * 3}px` }}>

                        {/* Group name (cup mode) */}
                        {dataSeason?.settings?.type?.type === 'cup' && (
                            <h3 style={{ color: color.first, textTransform: 'uppercase', fontSize: `${3 * px}px`, textAlign: 'center', marginBottom: `${px}px`, textShadow: `0 0 10px ${color.first}` }}>
                                {t('group')} {group?.name}
                            </h3>
                        )}

                        {/* Table */}
                        <div style={{ width: '100%', border: `1px solid rgba(0,180,216,0.4)`, borderRadius: `${px * 1.5}px`, overflow: 'hidden', boxShadow: `0 0 25px rgba(0,180,216,0.12)`, backdropFilter: 'blur(8px)' }}>
                            <table width="100%" style={{ borderCollapse: 'collapse' }}>
                                <thead>
                                    <tr style={{ background: `linear-gradient(90deg, rgba(0,119,182,0.9), rgba(0,180,216,0.7), rgba(0,119,182,0.9))` }}>
                                        <td style={{ color: color.second, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', width: '5%', padding: `${px * 1}px ${px * 0.5}px`, textAlign: 'center', textShadow: `0 0 6px ${color.first}` }}>#</td>
                                        <td style={{ color: color.text, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', width: '28%', textTransform: 'uppercase', padding: `${px * 1}px ${px * 0.5}px` }}>{t('team')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('games_played_app')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('wins_app')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('draw_app')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('lose_app')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('goals_for_app')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('goals_against_app')}</td>
                                        <td style={{ color: color.fourth, fontSize: `${1.8 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 1}px ${px * 0.5}px` }}>{t('goal_difference_app')}</td>
                                        <td style={{ color: color.second, fontSize: `${2 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '8%', padding: `${px * 1}px ${px * 0.5}px`, textShadow: `0 0 8px ${color.first}` }}>{t('points_app')}</td>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[...group?.teams].map((team, teamIdx) => (
                                        <tr
                                            key={`${team?.recordId}-${new Date().getTime()}`}
                                            style={{
                                                background: teamIdx % 2 === 0 ? color.rowOdd : color.rowEven,
                                                borderBottom: `1px solid rgba(0,180,216,0.12)`
                                            }}
                                        >
                                            {/* Rank */}
                                            <td style={{ color: color.first, fontSize: `${2 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', width: '5%', padding: `${px * 0.9}px ${px * 0.5}px`, textAlign: 'center', fontWeight: 'bold' }}>{teamIdx + 1}</td>
                                            {/* Team name */}
                                            <td style={{ color: color.text, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textTransform: 'uppercase', width: '28%', padding: `${px * 0.9}px ${px * 0.5}px`, fontWeight: 'bold' }}>{team?.name}</td>
                                            {/* GP */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalMatches || 0}</td>
                                            {/* W */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalWinMatches || 0}</td>
                                            {/* D */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalDrawMatches || 0}</td>
                                            {/* L */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalLoseMatches || 0}</td>
                                            {/* GF */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalGoals || 0}</td>
                                            {/* GA */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalLoseGoals || 0}</td>
                                            {/* GD */}
                                            <td style={{ color: color.subText, fontSize: `${1.9 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '7%', padding: `${px * 0.9}px ${px * 0.5}px` }}>{team?.totalDifferences || 0}</td>
                                            {/* PTS – ocean blue highlight */}
                                            <td style={{ color: color.second, fontSize: `${2.2 * px}px`, fontFamily: 'SFUHelveticaCondensedBold', textAlign: 'center', width: '8%', padding: `${px * 0.9}px ${px * 0.5}px`, fontWeight: 'bold', textShadow: `0 0 8px ${color.first}` }}>{team?.totalScores || 0}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                ))}

                {/* Footer */}
                <p style={{ textAlign: 'right', color: `rgba(202,240,248,0.5)`, fontSize: `${2 * px}px`, fontWeight: 'bold', margin: `${px}px 0 0 0`, textShadow: '0 2px 4px rgba(0,0,0,1)' }}>
                    {window.sessionStorage.getItem('HomeUrl') || 'VSPORT EXCLUSIVE'}
                </p>
            </div>
        </div>
    )
}

const Image = props => {
    const [data, setData] = React.useState(null)
    React.useEffect(() => {
        if (props.src) {
            getBase64(props.src).then(r => setData(r))
        }
    }, [props.src])
    return <img {...props} src={data} alt="" />
}

const areEqual = (p, n) => {
    return JSON.stringify(p.dataSeason) === JSON.stringify(n.dataSeason) &&
        JSON.stringify(p.dataTable) === JSON.stringify(n.dataTable)
}

export default React.memo(Mauranking5, areEqual)
